import { LeagueList } from '../ui/LeagueList.tsx';

export function LeagueScreen() {
  return (
    <div className="screen">
      <div className="screen__head">
        <h1 className="t-screen">Лига</h1>
      </div>
      <p className="t-meta league-screen__lead">Опыт за эту неделю (с понедельника). XP дают только верные ответы и повторения.</p>
      <section className="card">
        <LeagueList />
      </section>
    </div>
  );
}
